<template>
  <div class="glo_Table">
    <el-table
      :height="T_Config.tableHeigth"
      header-align="center"
      ref="tables"
      @row-click="rowclick"
      :data="T_Config.tableData"
      border
      stripe
      :highlight-current-row="true"
      :show-summary="isShowSumm"
      :summary-method="getSummaries"
      @selection-change="selectionChange"
    >
      <el-table-column
        fixed="left"
        align="center"
        label="序号"
        type="index"
        width="60"
      />
      <el-table-column
        v-if="checkbox"
        fixed="left"
        align="center"
        type="selection"
        width="60"
      />
      <template v-for="(item, index) in T_defaultHead">
        <!-- 渲染表格右边按钮 -->
        <template v-if="item.field === 'edit'">
          <el-table-column
            fixed="right"
            :label="item.name"
            :key="index"
            :min-width="item.width || 120"
          >
            <template slot-scope="scope">
              <div class="tabRightBtns">
                <template v-for="(opt, keys) in item.Buttons">
                  <el-button
                    :key="keys"
                    v-if="hasPermiss(opt.permissVal) || !opt.permissVal"
                    class="rbtns"
                    @click.stop="Callback(scope.row, opt.method)"
                  >
                    {{ opt.methodName }}
                  </el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </template>

        <!-- 表格正常需要显示的字段 -->
        <template v-if="item && item.isShow">
          <my-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            :sortable="item.isSort || false"
            :show-overflow-tooltip="true"
            :min-width="item.width || 120"
            :data-isTotal="item.isTotal || false"
          >
            <template slot-scope="scope">
              <!-- 多字段显示 -->
              <span
                v-if="item.MultiAttr == 'isFields'"
                v-for="(f, n) in item.fields"
                :key="n"
              >
                {{ scope.row[f] }}
              </span>
              <!-- 嵌入输入框 -->
              <el-input
                v-if="item.MultiAttr == 'Editable'"
                v-model="scope.row[item.field]"
                placeholder="请输入"
              />
              <!-- 超链接点击可跳转 -->
              <div
                v-if="item.MultiAttr == 'Hyperlink'"
                class="linkTabel"
                @click.stop="goYdDetails(scope.row)"
              >
                {{ scope.row[item.field] }}
              </div>
              <!-- 正常显示 -->
              <span v-if="!item.MultiAttr">
                {{ scope.row[item.field] }}
              </span>
            </template>
          </my-table-column>
        </template>
      </template>
    </el-table>
  </div>
</template>
<script >
import MyTableColumn from '@/components/table/TableColumn.vue'
export default {
  components: {
    MyTableColumn
  },
  props: {
    tableConfig: {
      type: Object,
    },
    defaulthead: {
      type: Array,
    },
    totals: {
      type: Array,
    },
    showSumm: {
      type: Boolean,
      default: true,
    },
    checkbox: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["selectChange", "jumpPage", "rowCallback"],
  data() {
    return {
      T_Config: this.tableConfig,
      T_defaultHead: this.defaulthead,
      T_totals: this.totals,
      isShowSumm: this.showSumm,
    };
  },
  watch: {
    tableConfig: {
      handler(newValue, oldValue) {
        this.T_Config = newValue;
      },
      deep: true, // 默认值是 false，代表是否深度监听
    },
    defaulthead: {
      handler(newValue, oldValue) {
        this.T_defaultHead = newValue;
      },
      deep: true, // 默认值是 false，代表是否深度监听
    },
    totals: {
      handler(newValue, oldValue) {
        this.T_totals = newValue;
      },
      deep: true, // 默认值是 false，代表是否深度监听
    },
  },

  methods: {
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.tables.toggleRowSelection(row);
    },
    Callback(e, methodname) {
      this.$emit("rowCallback", e, methodname);
    },
    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.T_totals.length; i++) {
          if (column.property === that.T_totals[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.tables.doLayout();
      });
      return sums;
    },
    selectionChange(e) {
      this.$emit("selectChange", e);
    },
    goYdDetails(a) {
      this.$emit("jumpPage", a);
    },
  },
};
</script>
<style scoped>
.linkTabel {
  cursor: pointer;
}
</style>
